import EvaluationBehavior from './evaluationBehavior'
import EvaluationScore from './evaluationScore'

const Configuration = () => {
  return (
    <>
      <EvaluationScore />
      <EvaluationBehavior />
    </>
  )
}

export default Configuration
